import React, { Component } from "react";
import modifyIcon from "../../../assets/ministry_edit_icon.svg";
import { ConfirmationComponent } from "../../ConfirmationComponent";
import CircleWithExclamation from "../../../assets/circle-with-exclamation.svg";
import { Modal, Button, Image, Form, Row } from "react-bootstrap";
import { FILE_FORMATS } from "../../../constant";
import ReactQuill from "react-quill";
import {
  handleLanguage,
  handlePaste,
  handleQuillLanguage
} from "../../../helper";
import "react-quill/dist/quill.snow.css";
import IconPin from "../../../assets/icon-pin.png";
import { get, isFunction } from "lodash";
import { UploadAttachmentsWithTitleComponent } from "../uploadAttchements";
import { DisplayAttachments } from "../displayAttachments";
import htmlToFormattedText from "html-to-formatted-text";
import {
  approveComment,
  issueActivityCommentParams
} from "../../../services/apiServices";
import request from "../../../services/requestService";
import { LoaderPage } from "../../../component/Loader";
import { toast } from "react-toastify";
import { errorToastStyle, successToastStyle } from "../../../customToast";
export default class ModifyAndApprove extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showCommentPopUp: false,
      canUploadVideo: true,
      languageError: null,
      pasteError: false,
      pastedText: "",
      comment: props.history || "",
      fileManagerDTOSet: props.file || [],
      isLoading: false
    };
  }

  componentDidUpdate(prevProps) {
    const { history, file } = this.props;

    if (prevProps.history !== history || prevProps.file !== file) {
      this.setState(
        {
          comment: history,
          fileManagerDTOSet: file
        },
        () => {
          // console.log(this.state.comment)
        }
      );
    }
  }
  toggleApprovePopUp = () => {
    const { showCommentPopUp } = this.state;

    if (showCommentPopUp) {
      this.setState({
        showCommentPopUp: false,
        comment: "",
        files: []
      });
      return;
    }

    this.setState({ loading: true }, () => {
      this.props.displayLoader(true);
    });

    setTimeout(() => {
      this.setState({
        loading: false,
        showCommentPopUp: true,
        comment: this.props.history || "",
        files: this.props.file || []
      });
    }, 1500);
  };

  onPostComment = async () => {
    console.log(this.state.comment, this.state.fileManagerDTOSet);
    const { commentId, getAllComments } = this.props;
    const { fileManagerDTOSet, comment } = this.state;

    const payload = {
      commentId: commentId,
      modifiedComment: comment.replace(
        /(<p>(?:<br>|&nbsp;|\s)*<\/p>\s*){2,}/g,
        "<p><br></p>"
      ),
      fileManagerDTOSet: fileManagerDTOSet
    };
    console.log(comment);
    try {
      this.setState(prevState => ({
        showCommentPopUp: !prevState.showCommentPopUp,
        isLoading: true
      }));

      const response = await request(approveComment(payload));
      //  console.log(response);

      if (response.data.status) {
        console.log(response);
        toast.success(
          <p className="toast-text-alignment">{response.data.message}</p>,
          successToastStyle
        );
        getAllComments("comment");
      } else {
        console.log(response);
        toast.error(
          <p className="toast-text-alignment">{response.data.message}</p>,
          errorToastStyle
        );
      }
    } catch (error) {
      console.error(error);
    } finally {
      // ✅ Stop loader immediately after API completes
      this.setState({ isLoading: false });
    }
  };
  onToggleAttachment = index => {
    //console.log(this.state.files)
    this.setState(prevState => {
      return {
        toggleAttachementDisplay: !prevState.toggleAttachementDisplay
      };
    });
  };
  onSuccessUploadOfAttachmets = async data => {
    try {
      this.setState(prevState => ({
        fileManagerDTOSet: [...prevState.fileManagerDTOSet, data]
      }));
    } catch (error) {
      //console.error(error.message);
    }
    console.log(data, this.state.fileManagerDTOSet);
  };
  // delete attachments
  onRemoveFile = ({ id }) => {
    try {
      this.setState(prevState => ({
        fileManagerDTOSet: prevState.fileManagerDTOSet.filter(
          val => val.id !== id
        )
      }));
    } catch (error) {
      console.log(`Error while deleting the image ${error.message}`);
    }
  };
  pasteLanguage = () => {
    // console.log("In paste language function");
    var cleanText = this.state.comment;
    // let cleanText = text
    //   .replace(/(<p><br\s*\/?><\/p>){2,}/gi, '<p><br></p>')
    //   .replace(/&nbsp;/g, ' ');
    const { issueDetails } = this.props;
    const project = get(issueDetails, "project");
    var nonEnglishChars = cleanText.replace(
      /[a-zA-Z0-9\s.,!?@#$%^&*()_+-=:;'"’‘<>\\/[\]{}|`~–——]/g,
      ""
    ).length; // Count non-English characters
    var alphanumericWithSpecial = cleanText.replace(
      /[^a-zA-Z0-9\s.,!?@#$%^&*()_+-=:;'"’‘<>\\/[\]{}|`~–—]/g,
      ""
    );

    if (
      nonEnglishChars > 0 &&
      (!cleanText.match(/[\u0900-\u097F]/) ||
        get(project, "sponsoredByCategory") != "STATE")
    ) {
      const originalComment = this.state.comment;
      const filteredText = originalComment.replace(
        /[^a-zA-Z\s.,!?@#$%^&*()_+-=:;'"’‘<>\\/[\]{}|`~–—]/g,
        "^"
      );
      if (filteredText.length > 8) {
        //console.log(filteredText)
        const stringWithSingleSpace = filteredText.replace(/\s+/g, " ");
        this.setState({
          comment: stringWithSingleSpace,
          languageError: true
        });
      } else {
        this.setState({ comment: "", languageError: true });
      }
    } else {
      this.setState({ comment: cleanText, languageError: false });
      if (
        !cleanText.match(/[\u0900-\u097F]/) ||
        get(project, "sponsoredByCategory") != "STATE"
      ) {
        let { filterString, hasBadValue } = handlePaste(this.state.comment);
        if (hasBadValue === true) {
          this.setState({
            pasteError: hasBadValue,
            comment: filterString
          });
        }
      }
    }
  };
  handleChange(html, event) {
    // console.log(html, event);
    const { projectData } = this.props;
    const project = projectData;

    const plainText = html.replace(/<[^>]*>/g, "").trim();
    const isBlank = !plainText || /^(<p><br><\/p>)+$/g.test(html); // only empty <p><br></p>

    const englishRegex = /^[A-Za-z\s.,!?'"()]*$/;
    const hindiRegex = /[\u0900-\u097F]/;
    if (englishRegex.test(plainText)) {
      if (html !== this.state.comment) {
        this.setState({
          languageError: false,
          pasteError: false,
          comment: html,
          textvalidation: true
        });
      }
    } else {
      console.warn("Hindi characters are not allowed.");
      if (html !== this.state.comment) {
        this.setState(
          {
            comment: html,
            textvalidation: true
          },
          () => {
            this.pasteLanguage();
          }
        );
      }
    }
  }

  render() {
    const {
      showCommentPopUp,
      toggleAttachementDisplay,
      canUploadVideo,
      comment,
      pasteError,
      error,
      fileManagerDTOSet,
      languageError,
      isLoading
    } = this.state;
    const { history, file, loading } = this.props;
    const toolbarConfig = {
      toolbar: [["bold", "italic"], [{ list: "ordered" }, { list: "bullet" }]]
    };
    const formats = [
      "header",
      "font",
      "size",
      "bold",
      "italic",
      "underline",
      "strike",
      "blockquote",
      "list",
      "bullet",
      "indent",
      "link",
      "image",
      "video"
    ];

    return (
      <>
        {/* {showCommentPopUp ? (
          <ConfirmationComponent
            show={showCommentPopUp}
            isLoading={false}
            modalClass={"confirmation-modal notification-delete"}
            // saveHandler={this.sendMeetingRequestPayload}
            closeHandler={this.toggleApprovePopUp}
            content={"Are you sure you want to approve?"}
          />
        ) : null} */}
        <LoaderPage loading={isLoading} />
        <Modal
          show={showCommentPopUp}
          onHide={this.toggleApprovePopUp}
          dialogClassName="modify-approve-modal"
          centered
        >
          {/* HEADER */}
          <Modal.Header closeButton>
            <Modal.Title>
              <div>Modify Comment</div>
            </Modal.Title>
          </Modal.Header>

          {/* BODY */}
          <Modal.Body>
            {/* Editor */}
            <Form className="update-status-form update-status-form-quill modify-comment-modal-quill">
              <div className="quill-field">
                <ReactQuill
                  value={comment}
                  ref={el => {
                    this.reactQuillRef = el;
                  }}
                  onChange={(html, event) => this.handleChange(html, event)}
                  theme="snow"
                  modules={toolbarConfig}
                  formats={formats}
                  bounds={".app"}
                />
                <Row
                  className="align-action justify-content-between remaining-char-div"
                  style={{
                    display:
                      languageError || (pasteError && comment !== "")
                        ? "block"
                        : null,
                    marginTop:
                      languageError || (pasteError && comment !== "")
                        ? "-2.7em"
                        : "-2em"
                  }}
                >
                  <span className="remaining-char-text">
                    Remaining characters :{" "}
                    <span
                      className="remaining-char-text"
                      style={{
                        color:
                          500 - htmlToFormattedText(comment).length < 0
                            ? "red"
                            : "#A2A3A2"
                      }}
                    >
                      {500 - htmlToFormattedText(comment).length}
                    </span>
                  </span>

                  {languageError || (pasteError && comment !== "") ? (
                    <div className="warning" style={{ marginLeft: -4 }}>
                      <Image src={CircleWithExclamation} />
                      Only English language is supported.
                    </div>
                  ) : (
                    <></>
                  )}
                </Row>
              </div>

              {toggleAttachementDisplay ? (
                <UploadAttachmentsWithTitleComponent
                  displayModal={toggleAttachementDisplay}
                  onCloseModal={this.onToggleAttachment}
                  fileFormats={FILE_FORMATS}
                  onSubmit={this.onSuccessUploadOfAttachmets}
                  canUploadVideo={canUploadVideo}
                  //handleDisplayTitle={this.handleDisplayTitle}
                  //displaytitle={true}
                />
              ) : null}
              <Form.Control.Feedback type="invalid">
                {languageError === true ||
                (pasteError === true && comment !== "")
                  ? ""
                  : get(error, "comment.message")}
              </Form.Control.Feedback>

              {this.state.fileManagerDTOSet.length == 0 ? null : (
                <>
                  <div className="newdiv">
                    <div className="newline" />
                  </div>
                </>
              )}
              {this.state.fileManagerDTOSet.length === 0 ? null : (
                <div className="new-attachment-update-status">
                  <DisplayAttachments
                    filesArr={fileManagerDTOSet}
                    onRemoveFile={this.onRemoveFile}
                    addAttchementRequired={false}
                    classes="attachments"
                    marginleft={this.props.marginleft}
                    updatestatusstyle={true}
                  />
                </div>
              )}

              <Form.Group className="field-attachment issue-detail-action">
                <div className="attachment-box attachment-box-ustatus">
                  <div
                    className="add-attachment"
                    onClick={this.onToggleAttachment}
                    style={{ marginLeft: 2 }}
                  >
                    <div className="add-attachment-button">
                      <Image src={IconPin} alt="Attachment Icon" />
                      Add Attachment
                    </div>
                  </div>
                </div>
                <div className="button-group post-comment">
                  <Button
                    className={`btn-orange no-padding modify-approve-btn`}
                    onClick={this.onPostComment}
                    style={{
                      marginTop: "3%",
                      padding: "12px 20px",
                      marginLeft: "-2em",
                      fontSize: "13px",
                      height: "44px",
                      width: "194px",
                      fontFamily: "mpb"
                    }}
                    disabled={
                      500 - htmlToFormattedText(comment).length < 0 ||
                      htmlToFormattedText(comment).length == 0
                        ? true
                        : false
                    }
                  >
                    {/* <div className="post-icon orange" /> */}
                    MODIFY & APPROVE
                  </Button>
                </div>
              </Form.Group>
            </Form>
            {/* Attachment */}
            {/* <div className="mt-3">
            <div className="add-attachment-button d-flex align-items-center">
              <Image src={IconPin} alt="Attachment" />
              <span style={{ marginLeft: "8px", cursor: "pointer" }}>
                Add Attachment
              </span>
            </div>
          </div> */}
          </Modal.Body>

          {/* FOOTER */}
        </Modal>
        <img
          src={modifyIcon}
          alt="approve"
          className="ministry-btn-icon"
          onClick={this.toggleApprovePopUp}
        />
      </>
    );
  }
}
